
















































































import {
  Vue, Prop, Component, Watch,
} from 'vue-property-decorator';
import ContractNotBilledFilter from '@/domain/contract/entity/contract-not-billed-filter.entity'
import EventBus, { Event } from '@/event.bus';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import ContractNotBilledService from '@/domain/contract/service/contract-not-billed.service'
import Pagination from '@/domain/pagination.entity';
import ContractNotBilled from '@/domain/contract/entity/contract-not-billed.entity'
import Response from '@/domain/response.entity';
import routeTo from '@/router/routeTo'
import ContractNotBilledFilterComponent from './contract-not-billed-modal-filter.component.vue'
import Header from './header.json'

@Component({
  components: { ContractNotBilledFilterComponent },
  filters: {},
})
export default class ContractNotBilledModal extends Vue {
  @Prop({
    required: true,
    default: false,
  })
  private showModal!: boolean;

  private businessUnitId = ''

  private contracts: ContractNotBilled[] = []

  private refs: any = this.$refs;

  private loading: boolean = false;

  private header = Header;

  private pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 10,
    defaultSort: 'customer.name|asc',
  })

  filter = new ContractNotBilledFilter();

  created() {
    this.businessUnitId = UserBusinessUnitService.currentBusinessUnit.id;
    if (this.businessUnitId) {
      EventBus.$off(Event.BUSINESS_UNIT_SELECTED);
    }
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnit: BusinessUnit) => {
      if (this.$route.name && (this.$route.name.includes('Faturamento') || this.$route.name.includes('BillingDataTable'))) {
        this.businessUnitId = businessUnit.id;
      }
    });
  }

  closeModal() {
    this.showModal = false;
    this.$emit('updateModalState', this.showModal);
    this.refs.filter.clear();
  }

  applyFilter(filter: ContractNotBilledFilter) {
    this.filter = new ContractNotBilledFilter(filter)
    this.getContractNotBilled();
  }

  updateTable() {
    this.pagination.verifyPage();
    this.getContractNotBilled();
  }

  getContractNotBilled() {
    this.loading = true;
    ContractNotBilledService.filter(this.pagination, this.businessUnitId, this.filter)
      .then((resp: Response) => {
        this.contracts = resp.content.map((it) => ContractNotBilled.of(it))
        this.pagination.total = resp.totalElements;
        this.pagination.pageCount = resp.totalPages;
      }).finally(() => this.loading = false)
  }

  goToContract(contractId: string): void {
    const route: any = {
      path: `/contract/${contractId}`,
    };

    routeTo(this.$router, route)
  }
}
